export const ALPHANUMERIC_SPECIAL_CHARACTERS_REGEX = /^[\w\d\s!@#$%^&*()|><?.]+$/
export const ALPHANUMERIC_AND_UNDERSCORE_WITH_WHITESPACE_REGEX = /^[\w\d\s]+$/
export const PHONE_REGEX = /^[\d\s-+]+$/
export const COMMON_TEXT_FIELD_REGEX = /^[\w\d\s'-.,]+$/
export const ALPHANUMERIC_WITH_SPACE_ONLY_REGEX = /^[A-Za-z0-9 ]+$/
// Allows alphanumeric characters, space and special characters ,-_
export const ALPHANUMERIC_WITH_SPACE_AND_SPECIAL_CHARACTERS_REGEX = /^[A-Za-z0-9,-_ ]+$/
// Allows alphanumeric and special characters -_
export const ALPHANUMERIC_WITH_HYPHEN_AND_UNDERSCORE_REGEX = /^[A-Za-z0-9-_]+$/
// Allows alphanumeric and special characters, but no spaces
export const ALPHANUMERIC_SPECIAL_CHARACTERS_NO_SPACES_REGEX =
  /^[\w\d!@#$%^&*()|><?.\-{}+=[\],;:`~'"\\/]+$/
export const COMMON_INTERNATIONAL_FIELD_REGEX =
  /^[\p{L}\p{M}\d]+[\p{L}\p{M}\p{Zs}\d.',-]*[\p{L}\p{M}\d.',-]+$/u
// Allows for versioning like 1.0.0-alpha+001 - minor and patch parts being optional
export const GENERIC_VERSION_REGEX =
  /^(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:-([0-9A-Za-z-.]+))?(?:\+([0-9A-Za-z-]+))?$/
// Allows alphanumeric and special characters, but no spaces
export const ALPHANUMERIC_ALL_SPECIAL_CHARACTERS_REGEX =
  /^[\w\d!@#$%^&*()|><?.\-{}+=[\],;:`~'"\\/ ]+$/
// Store version to force-update against: two or three dot-separated numbers, no
// leading zeros, at most 3 digits per segment ("4.0", "5.12", "5.0.13",
// "10.0.15"). Shared by iOS and Android — the two are numbered independently but
// written the same way, and mobile compares both with semver.coerce. Anchored,
// so an interior space is rejected; leading/trailing space is stripped by the
// callers' trim before this runs.
//
// A dot is REQUIRED, which is what rules out a bare integer like "11111111".
// semver.coerce reads a dotless value as a major version (11111111 -> 11111111.0.0),
// so a fat-fingered one sits above every shipped build: with the platform's force
// flag on, every user gets a non-dismissible "Update Now" pointing at a store
// build that does not exist. Requiring a dot closes that typo class. It cannot
// close all of it — "99.0.0" is well-formed and still gates everyone — but no
// format rule can; the admin must enter a version that actually shipped.
// Password policy shared by the admin "Update user password" dialog (via
// shared/utils/validations.util.js) and the server-side schema that re-checks it.
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 50
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/
export const PASSWORD_SPECIAL_CHARACTERS_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/

export const ABOUT_MAX_LENGTH = 999

export const APP_VERSION_REGEX = /^(?:0|[1-9]\d{0,2})(?:\.(?:0|[1-9]\d{0,2})){1,2}$/
// Fits every realistic store version up to "99.99.99". A single 3-digit segment
// still fits ("100.0.15"), but "10.10.100" does not — widen this if a patch
// number ever passes 99 while major and minor are both 2 digits.
export const APP_VERSION_MAX_LENGTH = 8
// Allows alphanumeric, blank spaces and only the special characters ;_+_.'
export const ALPHANUMERIC_WITH_SPACE_AND_SPECIAL_CHARACTERS_FOR_SITE_GROUPS_REGEX =
  /^[A-Za-z0-9 ;/\-+_.']+$/

export const INSTAGRAM_HANDLE_REGEX = /^[a-zA-Z0-9._]+$/

// Canonical UUID shape (8-4-4-4-12 hex, any case, no version restriction).
// Exposed both as a string pattern (for declarative validation configs that
// serialize rules, e.g. the import field-config engine) and as a compiled
// RegExp (for direct `.test()` callers like the CSV-import transformers).
export const UUID_PATTERN =
  '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
export const UUID_REGEX = new RegExp(UUID_PATTERN)
